var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import EmailInput from './EmailInput';
import PasswordInput from './PasswordInput';
import DateInput from './DateInput';
import { ErrorMessage } from './ErrorMessage';
import NumberInput from './NumberInput';
import { BasicInput } from './BasicInput';
/**
 * <p>This component can be configured to render one of the following input types: `number`, `email`, `date` or `password`. If no
 * type is passed to this component it will render an input of type `text` by default.</p>
 */
var Input = function (_a) {
    var type = _a.type, props = __rest(_a, ["type"]);
    var MatchedInput;
    switch (type) {
        case 'number':
            MatchedInput = NumberInput;
            break;
        case 'email':
            MatchedInput = EmailInput;
            break;
        case 'date':
            MatchedInput = DateInput;
            break;
        case 'password':
            MatchedInput = PasswordInput;
            break;
        case 'text':
        default:
            MatchedInput = BasicInput;
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(MatchedInput, __assign({}, props));
};
export { Input, BasicInput, NumberInput, EmailInput, PasswordInput, ErrorMessage };
export default Input;
//# sourceMappingURL=index.js.map